import { normalPriceCount } from "../../../env";

function CustomerTableRow(props) {
  const singleUser = props.info;
  return (
    <tr>
      <td>{props.index + 1}</td>
      <td>{singleUser.sName}</td>
      <td style={{ whiteSpace: "nowrap", fontSize: ".75rem" }}>
        {singleUser.username}
      </td>
      <td>{singleUser.mobile ? singleUser.mobile : "-"}</td>
    </tr>
  );
}
export default CustomerTableRow;
